export default {
    o2oviewFormDetails: {
        Cancel: 'Cancel order',
        Confirm: 'Confirm receipt',
        Copy: 'Copy Order',
        Rejected: 'Rejected',
        Reason: 'Reason:',
        Reviewed: 'Reviewed by',
        Approval: 'Date Approved',
        Closed: 'Closed',
        Add: 'Add tags',
        O2O: 'O2O information',
        Pickup: 'Pickup method',
        store: 'Pickup store',
        employee: 'Sales employee',
        Description: 'Description',
        voucher: 'Consumption voucher',
        Basic: 'Account Information',
        Order: 'Order Type',
        Third: 'Third party Order No.',
        number: 'CSG Order No.',
        Sales: 'Store',
        Three: 'Three party order placement time',
        creation: 'Internal Creation Time',
        Buyer: 'Buyer comments',
        Modify: 'Modify',
        Merchant: 'Merchant comments',
        service: 'Customer service comments',
        Receiving: 'Receiving information',
        nickname: "Buyer's nickname",
        Consignee: 'Full Name',
        Phone: 'Phone',
        Address: 'Address',
        Amount: 'Amount information',
        Total: 'Total amount of goods',
        payable: 'Total amount payable by buyer',
        cost: 'Total cost amount',
        Payment: 'Payment information',
        method: 'Payment method',
        Modistatusfy: 'Payment status',
        time: 'Payment time',
        actual: "Buyer's actual payment amount",
        Yuan: 'Yuan',
        Invoice: 'Invoice information',
        View: 'View details',
        type: 'Invoice type',
        header: 'Invoice header',
        content: 'Invoice content',
        invoicing: 'No invoicing application currently',
        information: 'Order Information',
        Product: 'Product Information',
        you: 'Do you want to cancel this order? Do you want to continue?',
        in: 'Operation in progress, do you want to continue?',
        only: 'Create a refund only form',
        return: 'Create a return order',
        refund: 'Create a return refund form',
        want: 'Do you want to delete this label?',
        error: 'Order information error: orderInfoVO. innerOrderNo=',
        receive: 'Are you sure you want to receive the goods?',
    }
};
